export const SET_SOCIETE_ACTIVE = 'SET_SOCIETE_ACTIVE';
export const SET_SOCIETES = 'SET_SOCIETES';
export const SET_SOCIETE_ACTIVE_ID = 'SET_SOCIETE_ACTIVE_ID';
export const SET_SUPPORT_COMMERCIAUX = 'SET_SUPPORT_COMMERCIAUX';
export const SET_LOGO = 'SET_LOGO';
